import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";
import { LOGO_ICON_URL } from "@/lib/assets";
import { Footer } from "@/components/Footer";

export default function LegalNotice() {
  const { t, lang, setLang } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${t("legal.title")} — MEDERNACH LIONEL DESIGNER`;
    return () => {
      document.title =
        "MEDERNACH LIONEL DESIGNER | Studio de design intérieur & extérieur — Luxembourg";
    };
  }, [t]);

  const sections = t("legal.sections");

  return (
    <div data-testid="legal-page" className="bg-[#0A1420] text-white min-h-screen">
      <header className="fixed top-0 inset-x-0 z-50 bg-[#0A1420]/85 backdrop-blur-md border-b border-white/10">
        <div className="max-w-[1000px] mx-auto px-6 sm:px-10 py-4 flex items-center justify-between">
          <Link to="/" data-testid="legal-home-link" className="flex items-center gap-3 group">
            <img src={LOGO_ICON_URL} alt="" aria-hidden="true" className="h-8 w-8 object-contain" />
            <span className="font-serif-lux text-sm tracking-[0.25em] uppercase text-[#A0ABC0] group-hover:text-[#D4AF37] transition-colors duration-300">
              Medernach Lionel
            </span>
          </Link>
          <div
            data-testid="legal-lang-toggle"
            className="flex items-center text-xs tracking-widest uppercase border border-white/15 px-2.5 py-1.5"
          >
            {["fr", "en", "lb"].map((l, i) => (
              <span key={l} className="flex items-center">
                {i > 0 && <span className="mx-1.5 opacity-30">/</span>}
                <button
                  onClick={() => setLang(l)}
                  data-testid={`legal-lang-${l}`}
                  className={`transition-colors duration-300 ${
                    lang === l ? "text-[#D4AF37]" : "text-[#A0ABC0] hover:text-white"
                  }`}
                >
                  {l.toUpperCase()}
                </button>
              </span>
            ))}
          </div>
        </div>
      </header>

      <main className="max-w-[900px] mx-auto px-6 sm:px-10 pt-36 pb-28">
        <p className="text-[#D4AF37] tracking-[0.3em] uppercase text-xs mb-6">
          © DREAMUP-design S.à r.l.
        </p>
        <h1
          data-testid="legal-title"
          className="font-serif-lux text-4xl sm:text-5xl lg:text-6xl leading-tight text-white mb-14"
        >
          {t("legal.title")}
        </h1>

        <div className="space-y-12">
          {sections.map((s, i) => (
            <section
              key={s.h}
              data-testid={`legal-section-${i}`}
              className="border-t border-[#D4AF37]/20 pt-8"
            >
              <h2 className="font-serif-lux text-2xl sm:text-3xl text-[#D4AF37] mb-5">{s.h}</h2>
              <div className="space-y-4">
                {s.p.map((para) => (
                  <p key={para} className="text-[#A0ABC0] font-light leading-relaxed">
                    {para}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-16">
          <Link
            to="/"
            data-testid="legal-back"
            className="inline-block border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#0A1420] transition-colors duration-300 px-8 py-4 uppercase tracking-widest text-xs"
          >
            {t("legal.backHome")}
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
